import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-card-stack.component.scss';
var ContentCardStack = /** @class */ (function (_super) {
    tslib_1.__extends(ContentCardStack, _super);
    function ContentCardStack(element) {
        return _super.call(this, element) || this;
    }
    ContentCardStack.prototype.init = function () {
    };
    ContentCardStack.prototype.bindEvents = function () {
    };
    return ContentCardStack;
}(Base));
export { ContentCardStack };



//////////////////
// WEBPACK FOOTER
// ./components/content-card-stack/content-card-stack.component.ts
// module id = 223
// module chunks = 0